<template>
  <div id="app">
    <GlobalNav />
    <transition name="page-fade" mode="out-in">
      <router-view :key="$route.path" class="top" />
    </transition>
    <GlobalFooter />
  </div>
</template>

<script>
  import GlobalNav from '@/components/GlobalNav.vue'
  import GlobalFooter from '@/components/GlobalFooter.vue'

  export default {
    components: {
      GlobalNav,
      GlobalFooter
    }
  }
</script>

<style lang="stylus">
  @import "./assets/styles/main.styl"
  @import './assets/styles/_variables.styl'
</style>
